import React, { useEffect, useState } from "react";
import { Modal, Typography, Button } from "@mui/material";

const TRSIIOptInModal = ({ isOpen, onClose, trsiiOptIn, handleTRSIIOptIn }) => {
  const acceptedTypes = [
    "text/csv",
    "text/x-csv",
    "application/x-csv",
    "application/csv",
    "text/x-comma-separated-values",
    "text/comma-separated-values",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  const handleOptInValue = (event) => {
    handleTRSIIOptIn();
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#FFF",
          padding: "20px",
          borderRadius: "4px",
        }}
      >
        <Typography variant="h6">OPT-OUT OPTION</Typography>

        <div
          style={{
            width: "800px",
            height: "200px",
            borderRadius: "4px",
            alignItems: "center",
            justifyContent: "center !important",
            cursor: "pointer",
            margin: "20px 0",
            textAlign: "justify",
          }}
        >
          <div>
            <p>
              Your company may opt out of being publicly scored if your company
              meets the eligibility criteria for classification as a Public
              Provisional Scorer (see TRSII SERVICER NARRATIVE). Your company’s
              seriously delinquent portfolio must be between 5 and 25 loans as
              reflected in Neighborhood Watch as of the date you make the
              request. It is up to you to determine if your company qualifies to
              opt-out and to make the request. HUD will validate and confirm via
              email your request upon submission if you do qualify to opt-out.
              This confirmation is notice of HUD’s determination that your
              company will be unranked in public records. If you choose to
              opt-out, your company will not be eligible for increased
              incentives even if you achieve Tier 1 for the final fiscal year
              end score. Please email sfdatarequests@hud.gov if you have any
              questions.{" "}
            </p>
          </div>
          <n />
          <div>
            {trsiiOptIn ? (
              <p>Are you sure you want to opt out ?</p>
            ) : (
              <p>Are you sure you want to opt in ?</p>
            )}
          </div>
        </div>
        <Button
          id="opt-in-button"
          variant="contained"
          onClick={handleOptInValue}
        >
          YES
        </Button>
        <Button
          id="trsii-opt-in-cancel-button"
          variant="contained"
          onClick={onClose}
          style={{ marginLeft: "10px" }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default TRSIIOptInModal;
